import React from 'react';
import {render} from 'react-dom';
import MainMenu from '../components/MainMenu';
import { CSSTransitionGroup } from 'react-transition-group';

const data = [
  { pic: './public/images/slider2.jpg', title: 'For All Your Accounting Needs.', path: '/team', name: 'OUR TEAM'},
  { pic: './public/images/slider3.jpg', title: 'For All Your Accounting Needs.', path: '/team', name: 'OUR TEAM'},
]

/*
const Card = (props) => {
  const { title, pic, path, name } = props;
  return(
    <div className="slider-card align-middle">
      <img src={pic} className="slider-card__image"/>
      <div className="slider-card__wrapper align-middle">
        {title}<br />
        <a href={path} className="header-card__button">{name}</a>
      </div>
    </div>
  );
}*/
const Card = (props) => {
  const { title, pic, path, name } = props;
  return(
    <div className="slider-card align-middle">
      <img src={pic} className="slider-card__image"/>
      <div className="slider-card__wrapper align-middle">
      </div>
    </div>
  );
}

class Slider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSlide: 0,
      countInterval: 0,
    };
  }
  componentWillMount() {
    const noOfSlides = data.length;
    this._timer = setInterval(() => {
      let state = this.state;
      const { currentSlide, countInterval } = state;
      if (countInterval === 6) {
        state.countInterval = 0;
        //nextSLide?
        let nextSlide = currentSlide + 1;
        nextSlide = (nextSlide === noOfSlides) ? 0 : nextSlide;
        state.currentSlide = nextSlide;
      }
      else {
        state.countInterval = countInterval + 1;
      }
      this.setState(state);
    }, 500);
  }
  componentWillUnmount() {
    clearInterval(this._timer);
  }
  render() {
    const { currentSlide } = this.state;
    const currentData = data[currentSlide];
    return (
      <div>
        <CSSTransitionGroup
          transitionAppear={false}
          transitionLeave={false}
          transitionName="home-slider"
          transitionEnterTimeout={1000}
          transitionLeaveTimeout={1000}>
          <Card {...currentData} key={currentSlide} />
        </CSSTransitionGroup>
      </div>
    );
  }
}

const HeaderSection = () => {
  return(
    <section className="section-header">
      <MainMenu fixedMenuTopHeight="500"/>
      <article className="section-header__slider">
        <Slider />
      </article>
    </section>
  );
};
export default HeaderSection;



// WEBPACK FOOTER //
// ./src/HomePage/HeaderSection.js